import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getOneClickResult } from '../../selectors/one-click-orders.selector';
import { createSelector } from '@ngrx/store';
import { getOneClickInvoiceSelected } from '../../selectors/one-click-contract.selector';

const resultAndInvoice = (index: number) =>
  createSelector(getOneClickResult, getOneClickInvoiceSelected(index), (result, invoice) => ({ result, invoice }));

export class OneClickNoResultHasInvoiceProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(resultAndInvoice(this.mapItem['index'])).pipe(
      map(({ result, invoice }) => {
        if (!result) {
          return true;
        } else {
          return !!invoice;
        }
      }),
    );
  }
}

export class OneClickNoResultNoInvoiceProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(resultAndInvoice(this.mapItem['index'])).pipe(
      map(({ result, invoice }) => {
        if (!result) {
          return true;
        } else {
          return !invoice;
        }
      }),
    );
  }
}
